import * as React from 'react'

import { i18n, useSiteConfig } from '@thg-commerce/enterprise-core'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { Separator } from '@thg-commerce/gravity-elements'
import { margin, styled, Text, TextStyling } from '@thg-commerce/gravity-theme'
import { Margin } from '@thg-commerce/gravity-theme/margin'

const Message = styled.p<{ margin?: Margin; textStyle?: TextStyling }>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'bodyText',
      props.textStyle?.style || 'default',
    )};
  ${(props) => props.margin && margin(props.margin)};
  text-transform: ${(props) => props.textStyle?.transform};
`

export const FreeDeliveryIndicator = () => {
  const { showProductPageFreeDeliveryText } = useSiteConfig()
  const theme = useTheme()
  const i18nText = {
    freeDelivery: {
      text: i18n('product.freedelivery.text'),
      href: i18n('product.freedelivery.href'),
    },
  }

  if (!showProductPageFreeDeliveryText) return null

  return i18nText.freeDelivery.text ? (
    i18nText.freeDelivery.href ? (
      <React.Fragment>
        <a href={i18nText.freeDelivery.href} rel="nofollow noreferrer">
          <Message
            margin={theme.pageTheme.freeDeliveryIndicator?.margin}
            textStyle={theme.pageTheme.freeDeliveryIndicator?.textStyle}
          >
            {i18nText.freeDelivery.text}
          </Message>{' '}
        </a>
        <Separator withSpacing />
      </React.Fragment>
    ) : (
      <React.Fragment>
        <Message
          margin={theme.pageTheme.freeDeliveryIndicator?.margin}
          textStyle={theme.pageTheme.freeDeliveryIndicator?.textStyle}
        >
          {i18nText.freeDelivery.text}
        </Message>{' '}
        <Separator withSpacing />
      </React.Fragment>
    )
  ) : null
}
